<h1 class="page-title w-50"> قطاع الغاز و البترول
</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/gasandpetrol.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span> تمتلك مصر دورًا رئيسيًا في أسواق الطاقة الإقليمية والعالمية</span>
      </div>
    </div>

    <div class="sector-content">
      <p>قطاع الغاز و البترول
      </p>
      <hr />
      <p> عن قطاع الغاز و البترول
        : </p>
      <p>
        في الواقع تعد مصر من ضمن أكبر عشر دول منتجة للنفط في القارة الإفريقية لعام 2022، تنتج مصر تنتج نحو 650 ألف برميل
        يوميًا، وتحتل المرتبة الخامسة ولديها أكبر سعة لتكرير النفط الخام في أفريقيا ومع زيادة الطلب من الأسواق
        الأوروبية، تتطلع مصر إلى تحسين الاستكشاف، مع التركيز بشكل خاص على حفر آبار جديدة..​تحظى مصر بدور رئيسي في أسواق
        الطاقة على المستوى الإقليمي والدولي، ويرجع ذلك على الأرجح إلى القرب الجغرافي والموقع الاستراتيجي عند مفترق طرق
        التجارة الدولية للنفط والغاز، بالإضافة إلى التحكم في مسارين رئيسيين للنقل في قناة السويس وخط أنابيب السويس
        والبحر الأبيض المتوسط (سوميد).
        تعتمد الخطة الاستراتيجية للطاقة في مصر على تنويع مصادر الطاقة وتوسعة مجالها والاستخدام الرشيد لمصادر الطاقة
        التقليدية.
        يعتبر النفط والغاز أحد الصناعات المفعمة بالنشاط في مصر، كما ان إنتاج الهيدروكربون يعد إلى حد بعيد من أكبر
        الأنشطة الصناعية الوحيدة في البلاد، مصر لديها موارد مهمة للطاقة تتمثل في الوقود الأحفوري التقليدي والطاقة
        المتجددة.
        بلغت احتياطيات مصر المؤكدة من الهيدروكربون ٣.٣ مليار برميل من النفط و٦٢.٨ تريليون قدم مكعب من الغاز الطبيعي في
        عام ٢٠١٧، تشجع الحكومة المصرية شركات النفط الدولية على المشاركة في قطاع النفط والغاز، وحالياً أكثر من خمسين شركة
        نفط تمارس نشاطها في مصر.
        ​تلعب مصر دوراُ حيوياُ في أسواق الطاقة الدولية من خلال تشغيل نقطتي عبور قناة السويس وخط أنابيب سوميد.
        إن قناة السويس، والتي تمت توسعتها في عام ٢٠١٥، تعتبر بمثابة طريق هام لعبور شحنات النفط والغاز الطبيعي المسال
        التي تتجه جنوباً من شمال افريقيا وعلى طول البحر الأبيض المتوسط إلى آسيا، إن الرسوم التي يتم تحصيلها من تشغيل
        نقطتي العبور تعتبر مصادر مهمة للإيرادات لصالح الحكومة المصرية.
        *وزارة البترول والثروة المعدنية
      </p>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=123">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>